import React from "react";
import { css } from "@emotion/react";
import { ReactComponent as Box } from "assets/images/wheel/box.svg";
import { fetchCampaign } from "actions";

import GTimer from "components/common/GTimer";
import { useAppDispatch, useAppSelector } from "redux/Store";
import { rgba } from "polished";

export default function SpinWheelBtn({ handleShow, fetchSpinWheelData }: any) {
  const { campaigns } = useAppSelector((state: any) => state.common) || { campaigns: null };
  const { campaign } = campaigns || {};
  const { minigamereward } = campaign || {};
  const endTime = minigamereward?.next_reset;
  const dispatch = useAppDispatch();

  return (
    <div css={spinBtnStyles} className="btn-trigger-spin">
      <button onClick={handleShow} className="btn spin-btn">
        <div className="spin-btn-text">
          <span>Claim</span> <span>your</span> <br /> <Box />
          <span>Spin</span>
        </div>
        <SpinWheelIcon />
      </button>
      <div css={countDownStyle} className="spin-timer">
        {!!endTime && (
          <GTimer
            onEnd={() => {
              dispatch(fetchCampaign());
              fetchSpinWheelData();
            }}
            expiredText="00:00:00:00"
            endTime={new Date(endTime).toISOString()}
            fields={["days", "hours", "minutes", "seconds"]}
            extendedDuration={true}
          />
        )}
      </div>
    </div>
  );
}

const SpinWheelIcon = () => (
  <svg width="62" height="64" className="spin-svg">
    <g>
      <path
        d="M31 63.325c16.586 0 30.031-13.445 30.031-30.03C61.031 16.707 47.586 3.262 31 3.262S.969 16.708.969 33.294 14.414 63.325 31 63.325Z"
        className="fill-primary"
        stroke="#131010"
      />
      <path d="M31 33.294 8.268 20.168a26.307 26.307 0 0 1 9.606-9.606L31 33.294Z" className="fill-secondary" />
      <path d="M31 7.042v26.252L17.874 10.562A26.004 26.004 0 0 1 31 7.042Z" className="fill-tertiary" />
      <path d="M44.126 10.562 31 33.294V7.042c4.784 0 9.266 1.274 13.126 3.52Z" className="fill-primary" />
      <path d="M53.733 20.168 31 33.294l13.126-22.732a26.31 26.31 0 0 1 9.607 9.606Z" className="fill-tertiary" />
      <path d="M57.252 33.294H31l22.733-13.126a26.003 26.003 0 0 1 3.52 13.126Z" className="fill-secondary" />
      <path d="M57.252 33.294c0 4.784-1.273 9.266-3.52 13.126L31 33.294h26.252Z" className="fill-tertiary" />
      <path d="M53.733 46.42a26.308 26.308 0 0 1-9.607 9.607L31 33.294 53.733 46.42Z" className="fill-primary" />
      <path d="M44.126 56.027A26.004 26.004 0 0 1 31 59.547V33.293l13.126 22.733Z" className="fill-tertiary" />
      <path d="M31 33.294v26.252a26.004 26.004 0 0 1-13.126-3.52L31 33.295Z" className="fill-secondary" />
      <path d="M31 33.294 17.874 56.027a26.31 26.31 0 0 1-9.606-9.607L31 33.294Z" className="fill-tertiary" />
      <path d="M31 33.294 8.268 46.42a26.003 26.003 0 0 1-3.52-13.126H31Z" className="fill-primary" />
      <path d="M31 33.294H4.748c0-4.784 1.273-9.266 3.52-13.126L31 33.294Z" className="fill-tertiary" />
      <path
        d="M31.053 40a6.947 6.947 0 1 0 0-13.893 6.947 6.947 0 0 0 0 13.893Z"
        className="fill-tertiary"
        stroke="#131010"
      />
      <g opacity=".5" className="fill-tertiary" stroke="#131010" strokeWidth="1.157">
        <path d="M52.506 40.61a1.553 1.553 0 1 0 0-3.106 1.553 1.553 0 0 0 0 3.106ZM9.494 29.085a1.553 1.553 0 1 0 0-3.107 1.553 1.553 0 0 0 0 3.107ZM36.763 13.341a1.553 1.553 0 1 0 0-3.106 1.553 1.553 0 0 0 0 3.106ZM25.237 56.354a1.553 1.553 0 1 0 0-3.107 1.553 1.553 0 0 0 0 3.107ZM46.743 50.59a1.553 1.553 0 1 0 0-3.106 1.553 1.553 0 0 0 0 3.107ZM15.257 19.104a1.553 1.553 0 1 0 0-3.107 1.553 1.553 0 0 0 0 3.107ZM46.743 19.104a1.553 1.553 0 1 0 0-3.107 1.553 1.553 0 0 0 0 3.107ZM15.257 50.59a1.553 1.553 0 1 0 0-3.106 1.553 1.553 0 0 0 0 3.107ZM9.494 40.61a1.553 1.553 0 1 0 0-3.106 1.553 1.553 0 0 0 0 3.106ZM52.506 29.085a1.553 1.553 0 1 0 0-3.107 1.553 1.553 0 0 0 0 3.107ZM25.237 13.341a1.553 1.553 0 1 0 0-3.106 1.553 1.553 0 0 0 0 3.106ZM36.763 56.354a1.553 1.553 0 1 0 0-3.107 1.553 1.553 0 0 0 0 3.107Z" />
      </g>
    </g>
  </svg>
);

const spinBtnStyles = (theme: ITheme) => css`
  position: fixed;
  bottom: 65px;
  right: 15px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  .spin-btn {
    font-weight: 500;
    color: #${theme.button.buttonTextColor};
    padding: 0;
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.1) 0 20px 25px -5px, rgba(0, 0, 0, 0.04) 0 10px 10px -5px;
    border-radius: 50%;
  }
  .spin-btn-text {
    position: absolute;
    top: -5px;
    left: -30px;
    line-height: 18px;
    white-space: nowrap;
    z-index: 99;
    span {
      font-family: "Spicy Rice", serif;
      font-weight: 600;
      font-style: normal;
      font-size: 22px;
      color: ${theme.button.primaryGradientStart};
      -webkit-text-stroke-width: 0.5px;
      -webkit-text-stroke-color: black;
      &:first-of-type {
      }
      &:nth-of-type(2) {
        font-size: 16px;
      }
      &:nth-of-type(3) {
        color: ${theme.button.tertiaryButtonBackground};
      }
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
      animation-timing-function: ease-out;
    }
    100% {
      transform: rotate(360deg);
      animation-timing-function: ease-in;
    }
  }
  .spin-svg {
    animation: spin 4s linear infinite;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    .fill-primary {
      fill: ${theme.button.primaryGradientStart};
    }
    .fill-secondary {
      fill: ${rgba(theme.button.primaryGradientStop, 0.2)};
    }
    .fill-tertiary {
      fill: ${theme.button.buttonTextColor};
    }
  }
`;
const countDownStyle = (theme: ITheme) => css`
  color: ${theme.text.tertiaryTextColor};
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
  max-width: 80px;
`;
